import SearchComponent from "../../components/search.component";
import ExportComponent from "../../components/export.component";
import {SORT_LIST_REVIEW} from "../../utils/sort-list";
import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {downloadFileExport} from "../../utils/general-variable";
import moment from "moment";
import SortComponent from "../../components/sort.component";
import PageLimitComponent from "../../components/page-limit.component";
import {DATA_LIMIT_LIST} from "../../utils/filter-list";
import React from "react";
import {setToolsModalVisibility} from "../../reducers/tools.reducer";

const ProductReviewFilter = () => {
    const dispatch = useDispatch()
    const {
        orderBy,
        sort,
        searchKey
    } = useSelector(state => state.toolsReducer)
    const {selectedRowKeysReview} = useSelector(state => state.reviewReducer)
    const {fetching: exportProductReviewList, isLoading} = useFetch(API.EXPORT_PRODUCT_REVIEW_LIST)

    const exportDataHandler = () => {
        const body = {
            order_by: orderBy ?? 'count',
            order_type: sort,
            search: searchKey,
            review_ids: selectedRowKeysReview
        }
        exportProductReviewList(body, '', {}, 'blob').then(res => {
            downloadFileExport(res, `Product-Review-List-Export-${moment().format()}.xlsx`)
        })
        dispatch(setToolsModalVisibility({export: false}))
    }

    return (
        <div className={"row justify-between my-5"}>
            <div className={"row space-x-5"}>
                <SearchComponent placeholder={"cari komentar..."}/>
                <div className={"row space-x-3"}>
                    <SortComponent sortList={SORT_LIST_REVIEW}/>
                    <PageLimitComponent limitList={DATA_LIMIT_LIST}/>
                    <div>
                        <ExportComponent
                            wordingConfirmation={`Apakah anda yakin ingin melakukan export data product review ?`}
                            countSelected={selectedRowKeysReview.length}
                            exportDataHandler={exportDataHandler}
                            isLoading={isLoading}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductReviewFilter
